import { ProductData } from '@appcharge/shared-ui';

interface IMappableProductEntry {
  productId: string;
  quantity?: number;
  quantityDisplay?: string;
}

export const mapToPreviewProducts = (
  products: any,
  productsList: IMappableProductEntry[]
): ProductData[] => {
  if (!products || productsList.length === 0) return [];

  return productsList.flatMap(({ productId, quantity, quantityDisplay }) => {
    const selectedProduct = products!.result.find(
      (product: ProductData) => product.productId === productId
    );
    if (!selectedProduct) return [];

    return [
      {
        ...selectedProduct,
        images: Object.fromEntries(
          selectedProduct.images.map(
            ({ type, url }: { type: string; url: string }) => [type, url]
          )
        ),
        quantity,
        quantityDisplay:
          quantityDisplay ||
          selectedProduct.quantityDisplay ||
          String(quantity)
      }
    ];
  });
};
